module.exports = __webpack_public_path__ + "static/WEDDING E&M-342-3dd1df5c23cf86a2252defe1fe53519a.jpg";